import { Field } from "react-final-form";
import TextField from "./TextField";

export default function DateOnlyField({ input, ...rest }) {
    return (
        <Field {...input} {...rest} type="date" component={TextField} />
    );
}
